import { useState, useEffect } from 'react';

import { useIntl } from 'react-intl';

import {
    BUSINESS_INTRODUCTION_STEP_ID,
    MY_ACCOUNTS_STEP_ID,
    STEP_ZERO_STEP_ID
} from '@src/containers/Routes/helper/stepActiveIds.helper';
import { redirectToURL } from '@src/helpers/redirection';

import { useNavigateToStep } from './useNavigateToStep';

export const useRedirectHandler = (
    furthestStepId: string | undefined,
    isApplicationStateLoading: boolean
) => {
    const [isLoading, setIsLoading] = useState(true);
    const { navigateToStep } = useNavigateToStep();
    const { locale } = useIntl();
    const isUK = locale === 'en';

    useEffect(() => {
        if (!isApplicationStateLoading) {
            if (!furthestStepId) {
                setIsLoading(false);

                return isUK
                    ? navigateToStep(STEP_ZERO_STEP_ID)
                    : navigateToStep(BUSINESS_INTRODUCTION_STEP_ID);
            }

            if (furthestStepId === MY_ACCOUNTS_STEP_ID) {
                return redirectToURL('/my_account/');
            }

            navigateToStep(furthestStepId);

            return setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return isLoading;
};
